import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {useTrackFeature} from '@aboutyou/tracking';
import {useCallback, useState} from 'react';

export const useWishlistSizeSelectionOpenedState = () => {
  const [productId, setProductId] = useState<number | undefined>();
  const [badgesListKeys, setBadgesListKeys] = useState<string[]>([]);
  const trackFeature = useTrackFeature();

  const {open, isOpen, cancel, hide, parameter} = useOpenedStateManager(
    'WISHLIST_SIZE_SELECTION',
  );

  const openSizeSelection = useCallback(
    ({
      productId,
      couponPromotionId,
      badgesListKeys,
    }: {
      productId: number;
      couponPromotionId?: string;
      badgesListKeys: string[];
    }) => {
      setProductId(productId);
      setBadgesListKeys(badgesListKeys);
      open({parameter: couponPromotionId});
      trackFeature({eventType: 'click', label: 'WL_A2B'});
    },
    [],
  );

  return {
    isSizeSelectionOpen: isOpen,
    productId,
    cancelSizeSelection: cancel,
    hideSizeSelection: hide,
    openSizeSelection,
    setProductId,
    couponPromotionId: parameter,
    badgesListKeys,
  };
};
